export default "__VITE_ASSET__DlHIXcDs__"